import {Button, Card, CardBody, CardFooter, CardHeader, Typography,} from "@material-tailwind/react";
import {ArrowDownTrayIcon} from "@heroicons/react/24/outline";
import React, {useEffect, useState} from "react";
import {ConsultationPaymentGrid} from "./grid";
import {Paginator} from "../system/paginator";
import {getFinishedReservation} from "../../services/reservation/reservation";
import {ConsultationPaymentForm} from "./form";
import {exportConsultationPayments} from "./export";
import {Toaster} from "../../helper/Toaster";
import {
  appendServiceFilterParams,
  SERVICE_FILTER_DEFAULTS,
  ServiceFilterContainer
} from "../shared/filters/service_filter_container";


export function ConsultationPaymentManagement() {

  const [consultationPayments, setConsultationPayments] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [filters, setFilters] = useState(SERVICE_FILTER_DEFAULTS);
  const [isExporting, setIsExporting] = useState(false);

  async function exportReport() {
    setIsExporting(true);
    try {
      await exportConsultationPayments(filters, sortBy, sortType);
    } catch (error) {
      Toaster.failure(null, "خطا در دریافت خروجی اکسل. لطفاً دوباره تلاش کنید.");
    } finally {
      setIsExporting(false);
    }
  }

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getFinishedReservation(paginate);
    if (result.status === 200) {
      const {consultationPaymentList, total_count} = result.data;
      setConsultationPayments(consultationPaymentList || []);
      setGridTotalRowCount(total_count)
    }
  }

  useEffect(() => {
    const paginateParams = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    })

    appendServiceFilterParams(paginateParams, filters);

    const paginate = paginateParams.toString()

    getData(paginate)
  }, [filters,
    gridCurrentPage,
    gridRowCount,
    sortBy,
    sortType,
    lastDataRefresh]);

  return (<div className="">
    <ConsultationPaymentForm consultationPayment={gridSelectedRow} open={modalOpen} setOpen={setModalOpen}
                             setLastDataRefresh={setLastDataRefresh} setGridSelectedRow={setGridSelectedRow}/>
    <Card className="pt-8">
      <CardHeader floated={true} shadow={false} className="rounded-none">
        <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
          <Typography variant="h5" color="blue-gray">تسویه مشاوره</Typography>
          <Button className="flex items-center gap-2" onClick={exportReport}
                  disabled={isExporting} loading={isExporting}>
            {!isExporting && <ArrowDownTrayIcon className="h-4 w-4"/>}
            {isExporting ? "در حال دریافت..." : "خروجی اکسل"}
          </Button>
        </div>
      </CardHeader>
      <CardBody className="overflow-x-auto w-full">
        <ServiceFilterContainer onFiltersChange={setFilters}/>

        <ConsultationPaymentGrid
          consultationPayments={consultationPayments}
          setModalOpen={setModalOpen}
          setSelectedRow={setGridSelectedRow}
          setSortBy={setSortBy}
          sortType={sortType}
          setSortType={setSortType}
        />
      </CardBody>
      <CardFooter className="flex items-center justify-center border-t border-blue-gray-50 p-4">
        <Paginator active={gridCurrentPage}
                   setActive={setGridCurrentPage}
                   totalRows={gridTotalRowCount}
                   rowsCount={gridRowCount}
                   setRowsCount={setGridRowCount}
                   from={from}
                   to={to}
        />
      </CardFooter>
    </Card>
  </div>);
}
